var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-btn',{attrs:{"to":'/pois' + _vm.apiString}},[_vm._v("Zur POI-Liste")])],1),_c('div',[_c('v-btn',{attrs:{"to":'/teaser' + _vm.apiString}},[_vm._v("Zur Teaser Übersicht")])],1),_c('div',[_c('v-btn',{attrs:{"to":'/summary' + _vm.apiString}},[_vm._v("Zur Summary")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }